export const interior_view02ImageOptions = {
  angle: 'interior_view02',
  staticOptions: {
    Floorboard: 1,
    Fabric: 1,
    FabricOwnersCabin: 1,
    CupboardsOwnersCabin: 1,
    BedsideCompartment: 1,
    Wardrobe: 1,
    AftCabinLayout: 1,
    Mast: 1,
    FabricSeatOwnersCabin: 1,
    FabricFreehung: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: null
    },
    {
      option: 'Fabric',
      dependency: 'AftCabinLayout'
    },
    {
      option: 'Worktop',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/interior_view02.js